import { cn } from '@/lib/utils'

interface DurationDisplayProps {
  seconds?: number
  className?: string
}

/**
 * Format duration from seconds to human-readable format
 */
export function formatDuration(seconds?: number): string {
  if (!seconds || seconds <= 0) {
    return '0s'
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)

  if (hours > 0) {
    return `${hours}h ${minutes}m ${secs}s`
  }
  if (minutes > 0) {
    return `${minutes}m ${secs}s`
  }
  return `${secs}s`
}

/**
 * Format duration as compact version (e.g., "2:45")
 */
export function formatDurationCompact(seconds?: number): string {
  if (!seconds || seconds <= 0) {
    return '0:00'
  }

  const hours = Math.floor(seconds / 3600)
  const minutes = Math.floor((seconds % 3600) / 60)
  const secs = Math.floor(seconds % 60)

  if (hours > 0) {
    return `${hours}:${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }
  return `${minutes}:${secs.toString().padStart(2, '0')}`
}

export function DurationDisplay({ seconds, className }: DurationDisplayProps) {
  return (
    <span className={cn('tabular-nums', className)}>
      {formatDuration(seconds)}
    </span>
  )
}

export default DurationDisplay
